import { render } from "./TopBuyers.vue?vue&type=template&id=838019b4&ts=true"
import script from "./TopBuyers.vue?vue&type=script&lang=ts"
export * from "./TopBuyers.vue?vue&type=script&lang=ts"

import "./TopBuyers.vue?vue&type=style&index=0&id=838019b4&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__